module.exports = __webpack_public_path__ + "static/img/chuangdianlist.7319ad57.png";